module.exports = __webpack_public_path__ + "static/media/Contrato.54e955cc.svg";